import { Modal } from 'react-bootstrap'
import '../../../scss/confirmation-modal.scss';
import { FaCheck } from 'react-icons/fa';

interface Props {
    handleClose: () => void;
    show?: boolean;
    orderNumber: string;
}

const OrderConfirmationModal = ({ handleClose, show=true, orderNumber }: Props) => {
    return (
        <Modal show={show} onHide={handleClose} centered contentClassName="final-price-modal">
            <Modal.Header closeButton></Modal.Header>
            <br />
            <div className="final-price-container">
                <div className="check-icon-wrapper">
                    <FaCheck className="check-icon" />
                </div>
                <h2 className="final-price-title">[{orderNumber}]’s Final Price Confirmed!</h2>
                <p className="final-price-subtitle">Let’s know when the order is ready for pickup.</p>
                <button className="pickup-button">Order Ready for Pickup</button>
            </div>
        </Modal>
    )
}

export default OrderConfirmationModal